var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('r-icon',{attrs:{"name":" ","size":18,"loading":""}}):_c('div',{class:['checkbox', `checkbox--${_vm.state}`]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }